import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'
import httpV3 from '../factory-api/https-v3'
import appConfig from '../appConfig'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [

    //引导页
    {
      path: '/guide-page',
      name: 'guide-page',
      component: resolve => {
        require(['../pages/guide-page/index.vue'], resolve)
      }
    },

    //中转页
    {
      path: '/loginwechat',
      name: '跳转中',
      meta: {
        title: '跳转中',
        requireAuth: false,   // 添加该字段，表示进入这个路由是需要登录的
      },
      component: resolve => {
        require(['../pages/transit/login-wechat.vue'], resolve)
      }
    },
    //切换企业中转页
    {
      path: '/transit',
      name: '跳转中',
      meta: {
        title: '跳转中',
        requireAuth: false,   // 添加该字段，表示进入这个路由是需要登录的
      },
      component: resolve => {
        require(['../pages/transit/index.vue'], resolve)
      }
    },
    //展会中转页
    {
      path: '/exhibition-wechat',
      name: '跳转中',
      meta: {
        title: '跳转中',
        requireAuth: false,   // 添加该字段，表示进入这个路由是需要登录的
      },
      component: resolve => {
        require(['../pages/transit/exhibition-wechat.vue'], resolve)
      }
    },
    {
      path: '/exhibition-bak',
      name: '跳转中',
      meta: {
        title: '跳转中',
        requireAuth: false,   // 添加该字段，表示进入这个路由是需要登录的
      },
      component: resolve => {
        require(['../pages/transit/exhibition-bak.vue'], resolve)
      }
    },

    //统一入口
    {
      path: '/',
      name: '',
      component: resolve => {
        require(['../pages/index.vue'], resolve)
      },
      children: [

        //世环会砸金蛋
        {
          path: 'egg-frenzy',
          name: '',
          meta: {
            title: '世环会砸金蛋',
          },
          component: resolve => {
            require(['../pages/egg-frenzy/index.vue'], resolve)
          },
        },

        //春节祝福
        {
          path: 'wish',
          name: '',
          meta: {
            title: '春节祝福',
          },
          component: resolve => {
            require(['../pages/wish/index.vue'], resolve)
          },
          children: [
            //默认跳转
            {
              path: '',
              redirect: 'map'
            },

            {
              path: 'map',
              name: '',
              meta: {
                title: '祝福地图',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: '',
                //PC端路由
                webPath: "",
              },
              component: resolve => {
                require(['../pages/wish/map.vue'], resolve)
              },
            },

            {
              path: 'record/:id',
              name: '',
              meta: {
                title: '祝福信息',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: '',
                //PC端路由
                webPath: "",
              },
              component: resolve => {
                require(['../pages/wish/record.vue'], resolve)
              },
            },
            {
              path: 'my-record',
              name: '',
              meta: {
                title: '我的祝福',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: '',
                //PC端路由
                webPath: "/wish/map",
              },
              component: resolve => {
                require(['../pages/wish/my-record.vue'], resolve)
              },
            },
          ]
        },

        //首页
        {
          path: '',
          name: '',
          component: resolve => {
            require(['../pages/home-page/index.vue'], resolve)
          }
        },
        //登录页面
        {
          path: 'login',
          name: '登录',
          meta: {
            title: '登录',

            //PC端访问是否需前往PC端
            isWeb: true,
          },
          component: resolve => {
            require(['../pages/user/login/index.vue'], resolve)
          }
        },
        //注册页面
        {
          path: 'register',
          name: '',
          meta: {
            title: '注册',

            //PC端访问是否需前往PC端
            isWeb: true,
          },
          component: resolve => {
            require(['../pages/user/register/index.vue'], resolve)
          }
        },
        //重置密码页面
        {
          path: 'reset',
          name: '',
          meta: {
            title: '重置密码',
          },
          component: resolve => {
            require(['../pages/user/reset-password/index.vue'], resolve)
          }
        },
        //完善信息页面
        {
          path: 'info-p',
          name: '',
          meta: {
            title: '完善信息',
          },
          component: resolve => {
            require(['../pages/user/information/imp-information-p.vue'], resolve)
          }
        },
        //完善信息页面
        {
          path: 'info',
          name: '',
          meta: {
            title: '完善信息',
          },
          component: resolve => {
            require(['../pages/user/information/imp-info.vue'], resolve)
          }
        },

        //首页
        {
          path: '',
          name: '',

          meta: {
            //PC端访问是否需前往PC端
            isWeb: true,
          },
          component: resolve => {
            require(['../pages/home-page/index.vue'], resolve)
          }
        },

        //环保学堂
        {
          path: '/environmental',
          name: '',
          component: resolve => {
            require(['../pages/environmental-school/index.vue'], resolve)
          },
          children: [
            {
              path: '',
              name: '环保学堂',
              meta: {
                title: '环保学堂',

                //PC端访问是否需前往PC端
                isWeb: true,
              },
              component: resolve => {
                require(['../pages/environmental-school/home-page.vue'], resolve)
              }
            },
            {
              path: 'course-center',
              name: '课程中心',
              meta: {
                title: '课程中心',

                //PC端访问是否需前往PC端
                isWeb: true,
              },
              component: resolve => {
                require(['../pages/environmental-school/course.vue'], resolve)
              }
            },
            {
              path: 'business/:id',
              name: '公司',
              meta: {
                title: '公司',

                //PC端访问是否需前往PC端
                isWeb: true,
              },
              component: resolve => {
                require(['../pages/environmental-school/business.vue'], resolve)
              }
            },
            {
              path: 'expert-center',
              name: '专家中心',
              meta: {
                title: '专家中心',
              },
              component: resolve => {
                require(['../pages/environmental-school/expert/index.vue'], resolve)
              },
              children: [
                {
                  path: '',
                  name: '专家中心',
                  meta: {
                    title: '专家中心',

                    //PC端访问是否需前往PC端
                    isWeb: true,
                  },
                  component: resolve => {
                    require(['../pages/environmental-school/expert/expert-center.vue'], resolve)
                  }
                },
                {
                  path: 'details/:id',
                  name: '专家详情',
                  meta: {
                    title: '专家详情',

                    //PC端访问是否需前往PC端
                    isWeb: true,
                  },
                  component: resolve => {
                    require(['../pages/environmental-school/expert/expert-details.vue'], resolve)
                  }
                },
              ]
            },
            {
              path: 'topic',
              name: '话题中心',
              meta: {
                title: '话题中心',
              },
              component: resolve => {
                require(['../pages/environmental-school/topic/index.vue'], resolve)
              },
              children: [
                {
                  path: '',
                  name: '话题中心',
                  meta: {
                    title: '话题中心',

                    //PC端访问是否需前往PC端
                    isWeb: true,
                  },
                  component: resolve => {
                    require(['../pages/environmental-school/topic/topic.vue'], resolve)
                  }
                },
                {
                  path: 'details/:id',
                  name: '话题详情',
                  meta: {
                    title: '话题详情',

                    //PC端访问是否需前往PC端
                    isWeb: true,
                  },
                  component: resolve => {
                    require(['../pages/environmental-school/topic/details.vue'], resolve)
                  }
                },
                {
                  path: 'search',
                  name: '搜索话题',
                  meta: {
                    title: '搜索话题',

                    //PC端访问是否需前往PC端
                    isWeb: true,
                  },
                  component: resolve => {
                    require(['../pages/environmental-school/topic/search.vue'], resolve)
                  }
                },
              ]
            },
            {
              path: 'environmental-protection',
              name: '将来学院',
              meta: {
                title: '将来学院',
              },
              component: resolve => {
                require(['../pages/environmental-school/environmental-protection/index.vue'], resolve)
              },
              children: [
                {
                  path: '',
                  name: '环保通首页',
                  meta: {
                    title: '环保通首页',

                    //PC端访问是否需前往PC端
                    isWeb: true,
                  },
                  component: resolve => {
                    require(['../pages/environmental-school/environmental-protection/environmental-protection.vue'], resolve)
                  }
                },
                {
                  path: 'classification/:id',
                  name: '环保通板块',
                  meta: {
                    title: '环保通板块',

                    //PC端访问是否需前往PC端
                    isWeb: true,
                  },
                  component: resolve => {
                    require(['../pages/environmental-school/environmental-protection/classification.vue'], resolve)
                  }
                },
                {
                  path: 'search',
                  name: '环保通搜索页',
                  meta: {
                    title: '环保通搜索页',

                    //PC端访问是否需前往PC端
                    isWeb: true,
                  },
                  component: resolve => {
                    require(['../pages/environmental-school/environmental-protection/search.vue'], resolve)
                  }
                },
                {
                  path: 'detail/:id',
                  name: '环保通详情',
                  meta: {
                    title: '环保通详情',

                    //PC端访问是否需前往PC端
                    isWeb: true,
                  },
                  component: resolve => {
                    require(['../pages/environmental-school/environmental-protection/detail.vue'], resolve)
                  }
                },
              ]
            },
            {
              path: 'technical-library',
              name: '技术文库',
              meta: {
                title: '技术文库',
              },
              component: resolve => {
                require(['../pages/environmental-school/technical-library/index.vue'], resolve)
              },
              children: [
                {
                  path: '',
                  name: '技术文库',
                  meta: {
                    title: '技术文库',

                    //PC端访问是否需前往PC端
                    isWeb: true,
                  },
                  component: resolve => {
                    require(['../pages/environmental-school/technical-library/technical-library.vue'], resolve)
                  }
                },
                {
                  path: 'detail/:id',
                  name: '技术文库',
                  meta: {
                    title: '技术文库',

                    //PC端访问是否需前往PC端
                    isWeb: true,
                  },
                  component: resolve => {
                    require(['../pages/environmental-school/technical-library/detail.vue'], resolve)
                  }
                },
              ]
            },
            {
              path: 'brand',
              name: '品牌官网',
              meta: {
                title: '品牌官网',

                //PC端访问是否需前往PC端
                isWeb: true,
              },
              component: resolve => {
                require(['../pages/environmental-school/brand.vue'], resolve)
              }
            }
          ]
        },

        //新闻中心
        {
          path: '/article',
          name: '',
          component: resolve => {
            require(['../pages/article-center/index.vue'], resolve)
          },
          children: [
            {
              path: '',
              name: '新闻中心',
              meta: {
                title: '新闻中心',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: '',
                //PC端路由
                webPath: "",
              },
              component: resolve => {
                require(['../pages/article-center/home-page/index.vue'], resolve)
              }
            },
            {
              path: 'search',
              name: '',
              meta: {
                title: '搜索',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: '',
                //PC端路由
                webPath: "",
              },
              component: resolve => {
                require(['../pages/article-center/search/index.vue'], resolve)
              }
            },
            {
              path: 'category',
              name: '',
              meta: {
                title: '分类搜索',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: '',
                //PC端路由
                webPath: "",
              },
              component: resolve => {
                require(['../pages/article-center/category/index.vue'], resolve)
              }
            },
            {
              path: 'details/:id',
              name: '',
              meta: {
                title: '详情页',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: '',
                //PC端路由
                webPath: "",
              },
              component: resolve => {
                require(['../pages/article-center/details/index.vue'], resolve)
              }
            },
          ]
        },

        //商城
        {
          path: '/mall',
          name: '',
          meta: {
            title: '商城',
          },
          component: resolve => {
            require(['../pages/mall/index.vue'], resolve)
          },
          children: [
            {
              path: '',
              name: '',
              meta: {
                title: '商城',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: 'mall',
                //PC端路由
                webPath: "/",
              },
              component: resolve => {
                require(['../pages/mall/mall.vue'], resolve)
              }
            },
            {
              path: 'goods-details/:id',
              name: '',
              meta: {
                title: '详情',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: 'mall',
                //PC端路由
                webPath: "/goods-details/:id",
              },
              component: resolve => {
                require(['../pages/mall/goods-details.vue'], resolve)
              }
            },
            {
              path: 'category',
              name: '',
              meta: {
                title: '分类',
              },
              component: resolve => {
                require(['../pages/mall/category.vue'], resolve)
              },
              children: [
                {
                  path: ':id',
                }
              ]
            },
            {
              path: 'shopping-cart',
              name: '',
              meta: {
                title: '购物车',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: '',
                //PC端路由
                webPath: "/shopping-cart",
              },
              component: resolve => {
                require(['../pages/mall/shopping-cart.vue'], resolve)
              }
            },
            {
              path: 'goods-list',
              name: '',
              meta: {
                title: '搜索页',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: 'mall',
                //PC端路由
                webPath: "/goods-list",
              },
              component: resolve => {
                require(['../pages/mall/goods-list.vue'], resolve)
              }
            },
            {
              path: 'primary-category/:id',
              name: '',
              meta: {
                title: '一级分类',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: 'mall',
                //PC端路由
                webPath: "/category/:id",
              },
              component: resolve => {
                require(['../pages/mall/primary-category.vue'], resolve)
              }
            },
            {
              path: 'shop/:id',
              name: '',
              meta: {
                title: '商铺',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: 'mall',
                //PC端路由
                webPath: "/shops/details/:id",
              },
              component: resolve => {
                require(['../pages/mall/shop.vue'], resolve)
              }
            },
            {
              path: 'brand/:id',
              name: '',
              meta: {
                title: '品牌',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: 'mall',
                //PC端路由
                webPath: "/brand/details/:id",
              },
              component: resolve => {
                require(['../pages/mall/brand.vue'], resolve)
              }
            },
          ]
        },

        //个人中心
        {
          path: '/center',
          name: '',
          meta: {
            title: '个人中心',
          },
          component: resolve => {
            require(['../pages/person-center/index.vue'], resolve)
          },
          children: [
            {
              path: '',
              name: '',
              meta: {
                title: '个人中心',
              },
              component: resolve => {
                require(['../pages/person-center/center.vue'], resolve)
              }
            },
            {
              path: 'collection',
              name: '',
              meta: {
                title: '收藏',
              },
              component: resolve => {
                require(['../pages/person-center/collection.vue'], resolve)
              }
            },
            {
              path: 'article',
              name: '',
              meta: {
                title: '新闻',
              },
              component: resolve => {
                require(['../pages/person-center/article.vue'], resolve)
              }
            },
            {
              path: 'school',
              name: '',
              meta: {
                title: '学院',
              },
              component: resolve => {
                require(['../pages/person-center/school.vue'], resolve)
              }
            },
            {
              path: 'active',
              name: '',
              meta: {
                title: '活动信息',
              },
              component: resolve => {
                require(['../pages/person-center/active.vue'], resolve)
              }
            },
          ]
        },

        //报价单
        {
          path: 'contract-confirm/:id',
          name: '报价单',
          meta: {
            title: '报价单',
          },
          component: resolve => {
            require(['../pages/mall/contract-confirm.vue'], resolve)
          }
        },

        //环博会
        {
          path: 'exhibition',
          component: resolve => {
            require(['../pages/exhibition/index.vue'], resolve)
          },
          children: [
            //首页
            {
              path: '',
              meta: {
                title: '环博会',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: 'mall',
                //PC端路由
                webPath: "/exhibition",
              },
              component: resolve => {
                require(['../pages/exhibition/home-page.vue'], resolve)
              }
            },
            //精彩集锦
            {
              path: 'events-photos/:date',
              meta: {
                title: '精彩集锦 - 环博会',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: 'mall',
                //PC端路由
                webPath: "/exhibition/events-photos/:date",
              },
              component: resolve => {
                require(['../pages/exhibition/events-photos.vue'], resolve)
              }
            },
            {
              path: 'news/:id',
              meta: {
                title: '精彩集锦 - 环博会',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: 'mall',
                //PC端路由
                webPath: "/exhibition/news/:id",
              },
              component: resolve => {
                require(['../pages/exhibition/news.vue'], resolve)
              }
            }
          ]
        },
        //世环会
        {
          path: 'world-protection',
          component: resolve => {
            require(['../pages/world-protection/index.vue'], resolve)
          },
          children: [
            //首页
            {
              path: '',
              meta: {
                title: '世环会',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: 'mall',
                //PC端路由
                webPath: "/world-protection",
              },
              component: resolve => {
                require(['../pages/world-protection/home-page.vue'], resolve)
              }
            },
            //精彩集锦
            {
              path: 'events-photos/:date',
              meta: {
                title: '精彩集锦 - 世环会',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: 'mall',
                //PC端路由
                webPath: "/world-protection/events-photos/:date",
              },
              component: resolve => {
                require(['../pages/world-protection/events-photos.vue'], resolve)
              }
            },
            {
              path: 'news/:id',
              meta: {
                title: '精彩集锦 - 世环会',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: 'mall',
                //PC端路由
                webPath: "/world-protection/news/:id",
              },
              component: resolve => {
                require(['../pages/world-protection/news.vue'], resolve)
              }
            },
            {
              path: 'manual',
              meta: {
                title: '展会手册 - 世环会',

                //PC端访问是否需前往PC端
                isWeb: true,
                //前往项目：mall为商城，默认为前台
                project: 'mall',
                //PC端路由
                webPath: "/world-protection/manual",
              },
              component: resolve => {
                require(['../pages/world-protection/manual.vue'], resolve)
              }
            }
          ]
        },
        //水务精灵
        {
          path: 'water-elves',
          name: '水务精灵',
          meta: {
            title: '水务精灵',

            //PC端访问是否需前往PC端
            isWeb: true,
            //前往项目：mall为商城，默认为前台
            project: '',
            //PC端路由
            webPath: "/water-elves",
          },
          component: resolve => {
            require(['../pages/water-elves/index.vue'], resolve)
          },
        },
        //OA模块
        {
          path: 'office-automation',
          name: 'office-automation',
          meta: {
            title: 'OA',

            //PC端访问是否需前往PC端
            isWeb: true,
            //前往项目：mall为商城，默认为前台
            project: '',
            //PC端路由
            webPath: "",
          },
          component: resolve => {
            require(['../pages/office-automation/index.vue'], resolve)
          },
          children: [
            //默认跳转
            {
              path: '',
              redirect: 'home'
            },
            //OA入口
            {
              path: 'home',
              name: '',
              meta: {
                title: 'OA',
                requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require(['../pages/office-automation/home/index.vue'], resolve)
              }
            },
            //日志模块
            {
              path: 'working-journal',
              name: '',
              meta: {
                title: '日志模块',
                requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require(['../pages/office-automation/working-journal/index.vue'], resolve)
              },
              children: [
                //默认跳转
                {
                  path: '',
                  redirect: 'journal-list'
                },
                {
                  path: 'procurement',
                  name: '',
                  meta: {
                    title: '写日志',
                    requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require(['../pages/office-automation/working-journal/procurement.vue'], resolve)
                  }
                },
                {
                  path: 'procurement-view',
                  name: '',
                  meta: {
                    title: '查看日志',
                    requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require(['../pages/office-automation/working-journal/procurement-view.vue'], resolve)
                  }
                },
                {
                  path: 'journal-list',
                  name: '',
                  meta: {
                    title: '日志列表',
                    requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require(['../pages/office-automation/working-journal/journal-list.vue'], resolve)
                  },
                  children: [
                    {
                      path: ":status",
                      meta: {
                        title: "",
                        requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                      },
                    }
                  ]
                },
              ]
            },
            //行政模块
            {
              path: 'administrative',
              name: '',
              meta: {
                title: '行政模块',
                requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require(['../pages/office-automation/administrative/index.vue'], resolve)
              },
              children: [
                //默认跳转
                {
                  path: '',
                  redirect: 'asset-classification'
                },
                {
                  path: 'asset-classification',
                  name: '',
                  meta: {
                    title: '资产分类',
                    requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require(['../pages/office-automation/administrative/asset-classification/index.vue'], resolve)
                  }
                },
                {
                  path: 'assets-management',
                  name: '',
                  meta: {
                    title: '资产管理',
                    requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require(['../pages/office-automation/administrative/assets-management/index.vue'], resolve)
                  },
                  children: [
                    //默认跳转
                    {
                      path: '',
                      redirect: 'list'
                    },
                    {
                      path: 'list',
                      name: '',
                      meta: {
                        title: '资产管理列表',
                        requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                      },
                      component: resolve => {
                        require(['../pages/office-automation/administrative/assets-management/list.vue'], resolve)
                      }
                    },
                    {
                      path: 'view',
                      name: '',
                      meta: {
                        title: '资产管理查看',
                        requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                      },
                      component: resolve => {
                        require(['../pages/office-automation/administrative/assets-management/view.vue'], resolve)
                      }
                    },

                    {
                      path: 'add-the-asset',
                      name: '',
                      meta: {
                        title: '添加资产',
                        requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                      },
                      component: resolve => {
                        require(['../pages/office-automation/administrative/assets-management/add-the-asset.vue'], resolve)
                      }
                    },
                  ]
                },
                {
                  path: 'my-assets',
                  name: '',
                  meta: {
                    title: '我的资产',
                    requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require(['../pages/office-automation/administrative/my-assets/index.vue'], resolve)
                  },
                  children: [
                    {
                      path: '',
                      redirect: 'list',
                    },
                    {
                      path: 'list',
                      name: '',
                      meta: {
                        title: '我的资产列表',
                        requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                      },
                      component: resolve => {
                        require(['../pages/office-automation/administrative/my-assets/list.vue'], resolve)
                      },
                      children: [
                        {
                          path: ":status",
                          meta: {
                            title: "",
                            requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                          },
                        }
                      ]
                    },
                    {
                      path: 'procurement',
                      name: '',
                      meta: {
                        title: '新增资产流',
                        requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                      },
                      component: resolve => {
                        require(['../pages/office-automation/administrative/my-assets/procurement.vue'], resolve)
                      }
                    },
                    {
                      path: 'procurement-view',
                      name: '',
                      meta: {
                        title: '操作资产流',
                        requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                      },
                      component: resolve => {
                        require(['../pages/office-automation/administrative/my-assets/procurement-view.vue'], resolve)
                      }
                    }
                  ]
                },
                {
                  path: 'journal-list',
                  name: '',
                  meta: {
                    title: '日志列表',
                    requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require(['../pages/office-automation/working-journal/journal-list.vue'], resolve)
                  }
                },
              ]
            },
            //财务模块
            {
              path: 'financing',
              name: '',
              meta: {
                title: '财务模块',
                requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require(['../pages/office-automation/financing/index.vue'], resolve)
              },
              children: [
                //默认跳转
                {
                  path: '',
                  redirect: 'reimbursement-list'
                },
                {
                  path: 'reimbursement-list',
                  name: '',
                  meta: {
                    title: '报销列表',
                    requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require(['../pages/office-automation/financing/reimbursement-list.vue'], resolve)
                  },
                  children: [
                    {
                      path: ":status",
                      meta: {
                        title: "",
                        requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                      },
                    }
                  ]
                },
                {
                  path: 'procurement',
                  name: '',
                  meta: {
                    title: '新增财务数据',
                    requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require(['../pages/office-automation/financing/procurement.vue'], resolve)
                  }
                },
                {
                  path: 'procurement-view',
                  name: '',
                  meta: {
                    title: '财务数据',
                    requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require(['../pages/office-automation/financing/procurement-view.vue'], resolve)
                  }
                }
              ]
            },
            //审批管理
            {
              path: 'approval-management',
              name: '',
              meta: {
                title: '审批模块',
                requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require(['../pages/office-automation/approval-management/index.vue'], resolve)
              },
              children: [
                //默认跳转
                {
                  path: '',
                  redirect: 'my-approval'
                },
                {
                  path: 'my-approval',
                  name: '',
                  meta: {
                    title: '审批管理',
                    requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require(['../pages/office-automation/approval-management/my-approval.vue'], resolve)
                  },
                  children: [
                    {
                      path: ":status",
                      meta: {
                        title: "",
                        requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                      },
                    }
                  ]
                },
                {
                  path: 'procurement',
                  name: '',
                  meta: {
                    title: '审批数据',
                    requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require(['../pages/office-automation/approval-management/procurement.vue'], resolve)
                  }
                }
              ]
            },
            //通用列表
            {
              path: 'currency',
              name: '',
              meta: {
                title: '通用模块',
                requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require(['../pages/office-automation/currency/index.vue'], resolve)
              },
              children: [
                //默认跳转
                {
                  path: '',
                  redirect: 'list'
                },
                {
                  path: 'list',
                  name: '',
                  meta: {
                    title: '通用列表',
                    requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require(['../pages/office-automation/currency/list.vue'], resolve)
                  }
                },
                {
                  path: 'list',
                  name: '',
                  meta: {
                    title: '通用列表',
                    requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require(['../pages/office-automation/currency/list.vue'], resolve)
                  },
                  children: [
                    {
                      path: ":status",
                      meta: {
                        title: "",
                        requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                      },
                    }
                  ]
                },
                {
                  path: 'procurement',
                  name: '',
                  meta: {
                    title: '新增通用数据',
                    requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require(['../pages/office-automation/currency/procurement.vue'], resolve)
                  }
                },
                {
                  path: 'procurement-view',
                  name: '',
                  meta: {
                    title: '通用数据',
                    requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require(['../pages/office-automation/currency/procurement-view.vue'], resolve)
                  }
                }
              ]
            }
          ]
        },
      ]
    },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js